import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Restaura o comportamento do Ionic 5 de "linha inteira clicável" para itens
 * que contêm um ion-radio/ion-checkbox.
 *
 * No Ionic 5, um ion-item com radio/checkbox dentro ganhava um button nativo
 * cobrindo o item todo, que encaminhava o clique ao controle — clicar no texto
 * selecionava. O Ionic 7+ removeu esse cover (o alvo clicável virou só o
 * próprio controle), quebrando a affordance de todas as linhas de seleção
 * (bordas/massas da pizza, extras, toppings, prêmios).
 *
 * Uso: <ion-item rowSelect> ... <ion-radio|ion-checkbox> ... </ion-item>
 * Clique em qualquer ponto do item é encaminhado ao primeiro controle
 * habilitado; cliques que já foram no controle não são duplicados; itens sem
 * controle são no-op.
 *
 * Guardião E2E: cypress/integration/rowAffordance/.
 */
@Directive({
	selector: 'ion-item[rowSelect]',
	standalone: true,
})
export class RowSelectDirective {
	constructor(private el: ElementRef<HTMLElement>) {}

	@HostListener('click', ['$event'])
	onClick(ev: Event): void {
		const target = ev.target as HTMLElement;
		// cliques em outros elementos interativos da linha (ex.: botões +/− dos
		// extras por quantidade) não devem ser encaminhados ao controle
		if (target.closest('ion-button, button, a, input, ion-input')) return;
		const control = this.el.nativeElement.querySelector<HTMLElement>('ion-radio, ion-checkbox');
		if (!control) return;                                   // linha sem controle (ex.: extra por quantidade)
		if (control.contains(target)) return;                   // clique já foi no controle — não duplicar
		if ((control as any).disabled) return;
		control.click();                                        // dispara a interação completa (toggle + ionChange)
	}
}
